import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import VueSweetalert2 from 'vue-sweetalert2'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import 'bootstrap/dist/js/bootstrap.js'
import VueI18n from 'vue-i18n'
import { locales } from './locales/langs'
import axios from 'axios'
import vueSmoothScroll from 'vue2-smooth-scroll'
import './assets/all.scss'

// Request interceptor
axios.interceptors.request.use(request => {
  return request
})

Vue.use(vueSmoothScroll)
Vue.use(VueI18n)
Vue.component(VueQrcode.name, VueQrcode)

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'tw',
  messages: locales
})

const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}

Vue.use(VueSweetalert2, options)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
